module.exports = __webpack_public_path__ + "93ee4e889b3bda50e4eeb7440fefa8f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/20_PROP_PRI_02.png
// module id = 121
// module chunks = 0